'use client';

import { useEffect, useRef } from 'react';
import { useAccountUm } from '@/hooks/use-account-um';
import { useGlobalContext } from '@/store/contexts/global-context';
import {
    maybeRunLoginGeolocation,
    prefetchLobbyGeolocation,
    resetLoginGeolocationDedupe
} from '@/logic/geolocation/run-login-geolocation';
import { LocationVerificationPillBar } from '../location-verification-pill/location-verification-pill-bar';
import { AMPLITUDE_EXPERIMENTS, isExperimentEnabled } from '@/utils/experiments';

export const LoginGeolocationEffects = () => {
    const { isLoggedIn, getSession, getUser } = useAccountUm();
    const { experiments, isAndroidWrapper, isIosWrapper, isXsellWrapper, isDesktop, region } = useGlobalContext();

    const isMobileWebLobby = !isAndroidWrapper && !isXsellWrapper && !isIosWrapper && !isDesktop;
    const getSessionRef = useRef(getSession);
    const getUserRef = useRef(getUser);

    useEffect(() => {
        getSessionRef.current = getSession;
    }, [getSession]);

    useEffect(() => {
        getUserRef.current = getUser;
    }, [getUser]);

    useEffect(() => {
        if (!isMobileWebLobby && !isDesktop) {
            return;
        }

        if (!isExperimentEnabled(experiments, AMPLITUDE_EXPERIMENTS.SAME_DOMAIN_LAUNCH)) {
            return;
        }

        prefetchLobbyGeolocation();

        if (!isLoggedIn) {
            resetLoginGeolocationDedupe();
            return;
        }

        let didCancel = false;

        const runGeolocation = async () => {
            const session = await getSessionRef.current();
            if (didCancel || !session) {
                return;
            }

            const user = await getUserRef.current();
            if (didCancel || !user?.userId) {
                return;
            }

            maybeRunLoginGeolocation({
                experiments,
                isMobileWebLobby,
                isDesktop,
                session: {
                    sessionId: session.sessionId,
                    token: session.token
                },
                userId: user.userId,
                region
            });
        };

        runGeolocation();

        return () => {
            didCancel = true;
        };
    }, [experiments, isLoggedIn, isMobileWebLobby, region, isDesktop]);

    return <LocationVerificationPillBar />;
};
